import * as constants from './types';

export default {
  [constants.SET_TASK_TABLE_PER_PAGE] (state, itemsPerPage) {
    state.tableOptions.itemsPerPage = itemsPerPage;
  },
  [constants.SET_TASK_VIEW_TYPE] (state, type) {
    state.viewType = type;
  },
}
